/*
 * @Autor: xx
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: xx
 * @Description:
 * @LastEditTime: 2020-05-26 18:18:21
 */

import { request } from "./api-require";
import { objAny } from "@/common/common-interface";

const API_URL = "/oms-operation-service/v1";

//查询汽车品牌
export const getCarBrandlist = (data = {}, config = {}) => {
  return request(API_URL + "/opr/carBrandTemplate/page", data, config);
};

//查询用户反馈的汽车的品牌
export const getCarBrandFallback = (data = {}, config = {}) => {
  return request(API_URL + "/opr/carBrandFallback/page", data, config);
};

// 删除汽车品牌
export const delCarBrandtemUpgrade = (data = {}, config = {}) => {
  return request(API_URL + "/opr/carBrandTemplate/delete", data, config);
};

// 新增汽车品牌
export const addCarBrandtemUpgrade = (data = {}, config = {}) => {
  return request(API_URL + "/opr/carBrandTemplate/add", data, config);
};

// 修改汽车品牌
export const upDataCar = (data = {}, config = {}) => {
  return request(API_URL + "/opr/carBrandTemplate/update", data, config);
};

// 查询汽车品牌详情
export const getCarBrandDetails = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/carBrandTemplate/detail", data, config);
};

// 查询汽车品牌下拉选项
export const getCarSelectOpts = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    API_URL + "/opr/carBrandTemplate/getCarRankType",
    data,
    config
  );
};
